import { render } from "./TextareaIanput.vue?vue&type=template&id=f896d4b2"
import script from "./TextareaIanput.vue?vue&type=script&lang=js"
export * from "./TextareaIanput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__